import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-app-sidebar-footer',
    templateUrl: './sidebar-footer.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiAppSidebarFooterComponent implements OnInit {
    @HostBinding() class = 'eui-app-sidebar-footer';

    constructor(
        private asService: UxAppShellService,
    ) {}

    ngOnInit() {
        this.asService.activateSidebarFooter();
    }
}
